import * as React from "react";
import {InputFieldState} from "./InputFieldState";
import {useEffect, useState} from "react";
import "./media-gallery.css"
import CloseIcon from '@mui/icons-material/Close';

export type MediaGalleryImage = {
    id: number,
    url: string,
}

type MediaGalleryProps = {
    image: MediaGalleryImage,
    label: string,
    onChange: (image: MediaGalleryImage) => void,
    buttonText: string,
}

export const MediaGallery = ({image, onChange, label, buttonText}: MediaGalleryProps) => {

    const [url, setUrl] = useState('');
    const [imageId, setImageId] = useState(null);

    const [showCloseBtn, setShowCloseBtn] = useState(false);

    useEffect(() => {
        if (image && image.id !== null && image.url !== null) {
            setImageId(image.id);
            setUrl(image.url);
            setShowCloseBtn(true);
        } else {
            setImageId(null);
            setUrl(null);
            setShowCloseBtn(false);
        }
    }, [image]);

    const upload = () => {
        //@ts-ignore
        const file_frame = wp.media.frames.file_frame = wp.media({
            title: 'Select or upload image',
            library: {
                type: 'image'
            },
            button: {
                text: 'Select'
            },
            multiple: false
        });

        // When an image is selected, run a callback.
        file_frame.on('select', function () {
            const attachment = file_frame.state().get('selection').first().toJSON();
            setUrl(attachment.url);
            setImageId(attachment.id);
            onChange({id: attachment.id, url: attachment.url});
            setShowCloseBtn(true);
        });

        file_frame.open();
        return false;
    }

    const removeImage = () => {
        setImageId(null);
        setShowCloseBtn(false);
        onChange(null);
        setUrl('');
    }

    return <React.Fragment>
        {label &&
            <label><span className="labelText">{label}</span></label>
        }
        <div className="media-gallery">
            {url &&
                <img src={url} alt=""/>
            }
            {showCloseBtn &&
                <a className={"close-btn"} type="button" onClick={() => removeImage()}><CloseIcon/></a>
            }
            <div className="admin-image-input">
                <input className="image-upload-button" type="button" value={buttonText} onClick={() => upload()}/>
            </div>
        </div>
    </React.Fragment>
}